import React, { useState } from 'react';

import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';

import AppActions from '../../actions/app-actions';
import { preformatWithRequestID } from '../../helpers';

const AddDevice = () => {
  const [uuid, setUuid] = useState('');
  const [postReq, setPostReq] = useState(false);
  const [successText, setSuccessText] = useState('');

  const showErrorMsg = (err, msg = '') => {
    const { body = {} } = err.res || {};
    const errormsg = body.error ? body.error.charAt(0).toUpperCase() + body.error.slice(1) 
      : 'Please check our connection';
    AppActions.setSnackbar(preformatWithRequestID(err.res, `${msg}. ${errormsg}`));
  };

  const handleAddOnClick = () => {
    setPostReq(true);
    setSuccessText('');
    AppActions.addDeviceToTenant(uuid)
      .then(() => {
        setSuccessText('Device has successfully added. Please go to Authorized tab.');
      })
      .catch(err => {
        showErrorMsg(err, 'Failed to add device');
      })
      .finally(() => {
        setPostReq(false);
      });
  };

  const handleUuidOnChange = (e) => {
    setUuid(e.target.value);
    setSuccessText('');
  };

  return (
    <div className="tab-container" style={{ marginTop: 60 }}>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Grid container justify='center'  alignItems='center'>
            <Grid item xs={4}>
              <TextField label='Please Enter UUID' value={uuid} onChange={handleUuidOnChange} 
                style={{ marginTop: 0, width: '100%' }} disabled={postReq} />
            </Grid>
            <Grid item>
              <Button color='primary' variant='contained' disabled={!uuid || postReq} onClick={handleAddOnClick}>Add</Button>
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12}>
          <Grid container justify='center'  alignItems='center'>
            <Grid item>
              <Typography>{successText}</Typography>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </div>
  );
};

export default AddDevice